import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const SendUpdateGalleryAction = createAsyncThunk(
  "SendUpdateGalleryAction",
  async (data1, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("UID", data1[0]["UID"]);
      formData.append("Name", data1[0]["Name"]);
      formData.append("Artist", data1[0]["Artist"]);
      formData.append("Details", data1[0]["Details"]);
      formData.append("Dimensions", data1[0]["Dimensions"]);
      formData.append("Price", data1[0]["Price"]);
      formData.append("Qty", data1[0]["Qty"]);
      formData.append("Type", data1[0]["Type"]);
      formData.append("HashTags", data1[0]["HashTags"]);
      formData.append("Show", data1[0]["Show"]);

      if (data1[2].length > 0) {
        formData.append("NoImages", (data1[2].length + 1).toString());
      } else {
        formData.append("NoImages", "KeepOld");
      }

      if (data1[1].length === 1) {
        formData.append("File001", data1[1][0]);
      }
      for (let i = 0; i < data1[2].length; i++) {
        formData.append("File00" + (i + 2).toString(), data1[2][i]);
      }

      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/UpdateGallery",
        formData,
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399 || error.code === "ERR_NETWORK") {
        localStorage.clear();
        window.location.assign("/");
      }
    }
  }
);

export const RequestUpdateGalleryAction = createAsyncThunk(
  "RequestUpdateGalleryAction",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/FetchUIDGallery",
        {
          UID: data1,
        },
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399 || error.code === "ERR_NETWORK") {
        localStorage.clear();
        window.location.assign("/");
      }
    }
  }
);

const UpdateGallerySlice = createSlice({
  name: "UpdateGallery",
  initialState: {
    isLoading: false,
    isSuccess: "hide",
    data: [],
  },

  extraReducers: (builder) => {
    builder
      .addCase(SendUpdateGalleryAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = "";
      })
      .addCase(SendUpdateGalleryAction.pending, (state, action) => {
        state.isLoading = true;
        state.isSuccess = "hide";
      })
      .addCase(RequestUpdateGalleryAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.isSuccess = "hide";
      })
      .addCase(RequestUpdateGalleryAction.pending, (state, action) => {
        state.isLoading = true;
        state.isSuccess = "hide";
      });
  },
});

export default UpdateGallerySlice.reducer;
